module.exports = __webpack_public_path__ + "img/West Bend_logo.5477dbd5.png";